import React, { useEffect, useState, useContext } from 'react';
import Swal from 'sweetalert2';
import { back } from '../../helpers/dataServer';
import '../css/Acordeon.css';
import { UserContext } from '../auth/context/UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk } from '@fortawesome/free-regular-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ListPerfiles } from './ListPerfiles';

export const ItemSelect = ({
  usuario,
  abierto,
  toggleAcordeon,
  perfilesNombres,
}) => {
  const [usuarioPerfil, setUsuarioPerfil] = useState([]);
  const [perfilesDesmarcados, setPerfilesDesmarcados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { dataUser } = useContext(UserContext);
  const { token } = dataUser;

  useEffect(() => {
    setUsuarioPerfil(usuario.perfiles.map((p) => p.id_perfil));
  }, [usuario.perfiles]);

  const handleCheckboxChange = (perfilId) => {
    setUsuarioPerfil((prev) => {
      if (prev.includes(perfilId)) {
        setPerfilesDesmarcados((prevState) => [...prevState, perfilId]);
        return prev.filter((id) => id !== perfilId); // Desmarcar
      }
      return [...prev, perfilId]; // Marcar
    });
  };

  const handleGrabarClick = async (event) => {
    event.stopPropagation();
    if (usuarioPerfil.length === 0) return;
    setIsLoading(true);

    try {
      await Promise.all(
        perfilesDesmarcados.map((perfilId) =>
          fetch(`${back}/usuariosperfiles/delusuariosperfiles`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: token,
            },
            body: JSON.stringify({
              id_usuario: usuario.id,
              id_perfil: perfilId,
            }),
          })
        )
      );

      const response = await fetch(
        `${back}/usuariosperfiles/addusuariosperfiles`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: token },
          body: JSON.stringify({
            id_usuario: usuario.id,
            id_perfil: usuarioPerfil,
          }),
        }
      );

      if (response.ok) {
        Swal.fire(
          'Información actualizada con éxito',
          'Actualización de Perfil Exitosa.',
          'success'
        );
        toggleAcordeon();
      } else {
        Swal.fire(
          'Error',
          'Hubo un error al actualizar información de Perfil.',
          'error'
        );
      }
    } catch (error) {
      console.error('Error en la actualización:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <button id="openfilterProfiles" onClick={toggleAcordeon}>
        <h2>Perfiles: </h2> {perfilesNombres}
      </button>

      {abierto && (
        <div className="miDiv" onClick={(e) => e.stopPropagation()}>
          <ListPerfiles
            usuarioPerfil={usuarioPerfil} // Pasa el estado de perfiles seleccionados
            onPerfilChange={handleCheckboxChange} // Pasa el manejador de cambios
            modoMultiple={true}
          />
          <button
            className="btnSaveProfile"
            onClick={handleGrabarClick}
            disabled={isLoading}
          >
            {isLoading ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <FontAwesomeIcon icon={faFloppyDisk} />
            )}
            <span>Grabar</span>
          </button>
        </div>
      )}
    </div>
  );
};
